import '@angular/localize/init';
export * from './lib/feature-tax-workflow-details.module';

export * from './lib/tax-workflow-details/feature-tax-workflow-details.component';
